import React, { useMemo, useState } from "react";
import { findArray } from 'helpers/utils'
import Pbp from 'components/general/Pbp'
import SportCode from "components/common/SportCode";
import Competitor from "components/presentation/Competitor";
import Noc from 'components/presentation/Noc';
import { useViewport } from 'components/general/useViewPort';
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const TkwPbp = ({ data, periodsOrder }) => {

  const configPpb = {
    centerRender: TkwRenderCenter,
    headerRender: TkwRenderHeader,
    sideRender: TkwtRenderSide,
    periodsOrder: periodsOrder,
    reverseSorting: true
  }

  return (<>
    <div className="box-hTKW">
      <strong><Label data='HeaderPlayByPlay' /></strong>
    </div>
    <Pbp data={data} config={configPpb} />
  </>);
}

const TkwRenderHeader = ({ home, away }) => {
  const { breakPoint } = useViewport();
  if (breakPoint === "sm" || breakPoint === "xs") {
    return ''
  }
  else {
    return (
      <strong>
        <div className="row box-center">
          <div className="col-5"><div className='d-flex justify-content-center'><Noc code={home?.participant.organisation.code} showImage={true} /><Competitor {...home?.participant} hidePicture={true} /></div></div>
          <div className="col-2"></div>
          <div className="col-5"><div className='d-flex justify-content-center'><Noc code={away?.participant.organisation.code} showImage={true} /><Competitor {...away?.participant} hidePicture={true} /></div></div>
        </div>
      </strong>
    )
  }
}

const TkwtRenderSide = ({ action, homeAway }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()

  const { breakPoint } = useViewport();

  let textAlign = 'end'

  if (breakPoint === "sm" || breakPoint === "xs")
    textAlign = 'start'


  const comp = action?.competitors?.find(item => item.pbpc_code === homeAway.participant?.code)
  const athleteCode = comp?.athletes?.find(item => item.pbpat_order === '1')?.pbpat_code
  const ath = homeAway?.teamAthletes?.find(item => item?.athlete?.code === athleteCode);

  let colour = findArray(homeAway?.teamAthletes.find(x => x !== undefined)?.eventUnitEntries, { eue_code: ['COLOUR'] })?.eue_value.toLowerCase();
  if (!comp) return;

  return (
    <>
      {colour === 'blue'
        ? <div className={`d-flex align-items-center flex-wrap justify-content-${textAlign} box-BK3`}>
          <Noc code={ath?.athlete?.organisation?.code} showImage={true} />
          <Competitor
            noc={homeAway?.participant?.organisation?.code}
            name={ath?.athlete?.name}
            shortName={ath?.athlete?.name}
            code={athleteCode}
            hidePicture={true}
            hideNoc={true} />
          {action?.pbpa_ActionAdd === 'TECHNIQUE'
            ? <div>,&nbsp;<SportCode discipline={mirs_discipline} entity='@Technique' code={action?.pbpa_Action} /></div>
            : action?.pbpa_ActionAdd === 'REQUEST'
              ? <div>,&nbsp;<SportCode discipline={mirs_discipline} entity='@RequestType' code={action?.pbpa_Action} /></div>
              : <div>,&nbsp;<SportCode discipline={mirs_discipline} entity='@IRM' code={action?.pbpa_Action} /></div>
          }

        </div>
        : <div className="d-flex align-items-center flex-wrap justify-content-start box-BK3">
          <Noc code={ath?.athlete?.organisation?.code} showImage={true} />
          <Competitor
            noc={homeAway?.participant?.organisation?.code}
            name={ath?.athlete?.name}
            shortName={ath?.athlete?.name}
            code={athleteCode}
            hidePicture={true}
            hideNoc={true} />
          {action?.pbpa_ActionAdd === 'TECHNIQUE'
            ? <div>,&nbsp;<SportCode discipline={mirs_discipline} entity='@Technique' code={action?.pbpa_Action} /></div>
            : action?.pbpa_ActionAdd === 'REQUEST'
              ? <div>,&nbsp;<SportCode discipline={mirs_discipline} entity='@RequestType' code={action?.pbpa_Action} /></div>
              : <div>,&nbsp;<SportCode discipline={mirs_discipline} entity='@IRM' code={action?.pbpa_Action} /></div>
          }

        </div>
      }

    </>
  )
}

const TkwRenderCenter = ({ action }) => {
  let [a, b, c] = ['', '', ''];

  if (action.competitors === undefined) {
    a = <div>{`${action?.pbpa_ActionDesc}  (${action?.pbpa_Action})`}</div>
  }

  b = <div>{action?.pbpa_When}</div>

  if (action.pbpa_Action === 'DSQ' || action.pbpa_Action === 'DQB' || action.pbpa_Action === 'WDR')
    b = <div>{action?.pbpa_Action}</div>

  if (action.pbpa_ScoreH) {
    c = <div><strong>{action?.pbpa_ScoreH} - {action?.pbpa_ScoreA}</strong></div>
  }
  return (<div className='box-center text-center'><strong>{a}{b}{c}</strong></div>);
}

export default TkwPbp